import PNotify from 'pnotify/dist/umd/PNotify';

const DEFAULT_RESPONSE_FN = () => {};

const DEFAULT_GLOBAL_MODAL_STATE = {
  show: false,
  options: {},
  responseFn: DEFAULT_RESPONSE_FN,
  slot: {
    component: null,
    options: {},
  },
};

const PNOTIFY_DEFAULT_POSITION = {
  dir1: 'down',
  dir2: 'left',
  firstpos1: 65,
  firstpos2: 25,
  push: 'top',
};

export default {
  namespaced: true,
  state: {
    globalModal: DEFAULT_GLOBAL_MODAL_STATE,
    notificationStack: {},
  },
  mutations: {
    // The update modal function will be executed without checking
    // The burden of checking should be done by its caller.
    $_updateModal(state, payload) {
      state.globalModal = payload;
    },

    $_updateNotificationStack(state, { id, notice }) {
      if (notice) {
        state.notificationStack[id] = notice;
      } else {
        delete state.notificationStack[id];
      }
    },
  },
  actions: {
    modal_open({ dispatch, commit, getters, rootGetters }, options) {
      const { slot } = options;
      if (!options.responseFn) options.responseFn = DEFAULT_RESPONSE_FN;

      // Close modal on invalid modal options
      if (!(slot && slot.component)) {
        dispatch('modal_close');
        throw new Error('Expecting the property `slot.component` to be valid');
      }

      const transientOptions = { ...options };
      transientOptions.show = true;
      commit('$_updateModal', transientOptions);
      options.responseFn('show');
    },

    modal_close({ dispatch, commit, getters, rootGetters }, options) {
      commit('$_updateModal', DEFAULT_GLOBAL_MODAL_STATE);
    },

    notify({ dispatch, commit, getters, rootGetters, state }, options) {
      if (!options.responseFn) options.responseFn = DEFAULT_RESPONSE_FN;
      if (options.type === 'warning') options.type = 'error';

      const notice = new PNotify({
        created: new Date().getTime(),
        target: document.body,
        data: {
          type: 'info',
          title: '',
          text: '',
          hide: true,
          stack: PNOTIFY_DEFAULT_POSITION,
          delay: 2500,
          modules: {
            Callbacks: {
              afterOpen(notice) {
                options.responseFn('show');
              },
              beforeClose(notice, timerHide) {
                options.responseFn('close');
                notice.fire('close', { notice, timerHide });
              },
            },
            Buttons: {
              sticker: false,
            },
          },

          ...options,
        },
      });

      notice.on('click', (event) => {
        // An extreme hack that target close and minimise button on pnotify
        if (event.target.nodeName !== 'SPAN') {
          options.responseFn('click');
        }
      });

      if (options.id != null) {
        const id = options.id;
        notice.on('close', (event) => {
          const closingNotice = event.notice;
          const currentNotice = state.notificationStack[id];
          if (closingNotice.options.created === currentNotice.options.created) {
            commit('$_updateNotificationStack', { id });
          }
        });
        if (state.notificationStack[id] != null) {
          state.notificationStack[id].close();
          // Note: These are synchronous callbacks. Expect your event to be
          // execute synchronously
        }
        commit('$_updateNotificationStack', { notice, id });
      }
    },
  },
};
